module.exports = __webpack_public_path__ + "img/daff.e64ff7ac.png";